import React from "react";
import { Select } from "components/select/index";
import DraggableEditInput from "components/draggableEditInput/DraggableEditInput";
import CustomSelectEdit from "pages/secure/facility/settings/forms/customEdits/CustomSelectEdit";
import CustomInputEdit from "pages/secure/facility/settings/forms/customEdits/CustomInputEdit";
import Input from "components/form/input/Input";
import CustomCheckboxEdit from "pages/secure/facility/settings/forms/customEdits/CustomCheckboxEdit";
import Checkbox from "components/form/checkbox/Checkbox";
import { TFacilityStatusInput } from "redux/reducers/models/facility";
import { useStatusInputContext } from "../StatusInputContextProvider";

interface IProps {
  input: TFacilityStatusInput;
}

export default function EditStatusInput(props: IProps) {
  const { Option } = Select;

  const { input } = props;

  const statusInputContext = useStatusInputContext();

  return (
    <DraggableEditInput
      item={input}
      rows={statusInputContext.inputRowsContainer?.updatedState}
      setSelectedEditInput={statusInputContext.setSelectedInput}
    >
      {input.type === "select" && (
        <CustomSelectEdit
          label={input.label}
          helpText={input.help_text}
          array={input.values}
          required={input.required}
          saveInput={(label, values, helpText, required) =>
            statusInputContext.handleUpdateInput(input.id, label, helpText, values, required)
          }
          editModalOpen={
            statusInputContext.selectedInput.id === input.id && statusInputContext.selectedInput.editModalOpen
          }
          closeEditModal={statusInputContext.closeInputEditModal}
          hideRequired
        >
          <Select label={input.label} helpText={input.help_text}>
            {!input.values || input?.values?.length < 1 ? (
              <Option key={"empty"} value={""}></Option>
            ) : (
              <>
                {input.values.map((value: string, index: number) => (
                  <Option key={index} value={value}>
                    <span
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        fontSize: "18px",
                      }}
                    >
                      {value}
                    </span>
                  </Option>
                ))}
              </>
            )}
          </Select>
        </CustomSelectEdit>
      )}

      {input.type === "input" && (
        <CustomInputEdit
          label={input.label}
          helpText={input.help_text}
          required={input.required}
          saveInput={(label, value, helpText, assignedAttribute, required) =>
            statusInputContext.handleUpdateInput(input.id, label, helpText, null, required)
          }
          editModalOpen={
            statusInputContext.selectedInput.id === input.id && statusInputContext.selectedInput.editModalOpen
          }
          closeEditModal={statusInputContext.closeInputEditModal}
          hideRequired
        >
          <Input id={input.id} label={input.label} helpText={input.help_text} defaultValue={input.values} readOnly />
        </CustomInputEdit>
      )}

      {input.type === "checkbox" && (
        <CustomCheckboxEdit
          label={input.label}
          helpText={input.help_text}
          required={input.required}
          options={input.values}
          saveInput={(label, helpText, required) =>
            statusInputContext.handleUpdateInput(input.id, label, helpText, null, required)
          }
          editModalOpen={
            statusInputContext.selectedInput.id === input.id && statusInputContext.selectedInput.editModalOpen
          }
          closeEditModal={statusInputContext.closeInputEditModal}
        >
          <Checkbox size="medium" label={input.label} supportText={input.help_text} checked={false} readOnly />
        </CustomCheckboxEdit>
      )}
    </DraggableEditInput>
  );
}
